
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';
import { VonageSessionData } from '@/entities/VonageSessionData';
import VirtualMeetingHighChart from '@/components/Common/VirtualMeetingHighChart.vue';
import VirtualMeetingComprehensiveDetails from '@/components/Common/VirtualMeetingComprehensiveDetails.vue';
import { Root } from '@/main';
@Component({
  components: {
    VirtualMeetingHighChart,
    VirtualMeetingComprehensiveDetails,
  },
})
class VirtualMeetingSessionAnalytics extends Vue {
  @Prop() private vonageAnalyticsForGraph?: VonageSessionData;
  @Prop() private selectedProgramId?: number;
  @Prop() private moduleType?: string;
  private vonageAnalyticslocal: VonageSessionData = VonageSessionData.createEmpty();
  private showCancelButton = false;
  private totalMeetingMinutes = 0;
  private averageSessionTime = 0;
  private moderators = 0;
  private created() {
    this.vonageAnalyticslocal = this.vonageAnalyticsForGraph!;
    if(this.vonageAnalyticslocal !== null && this.vonageAnalyticslocal !== undefined) {
      this.totalMeetingMinutes = this.vonageAnalyticslocal.TotalMinutesOfMeeting;
      this.averageSessionTime =  this.vonageAnalyticslocal.AverageSessionTime;
      this.moderators =  this.vonageAnalyticslocal.ModeratorsCount;
    }
  }

  private Cancel() {
    Root.emit('reload-program-detail');
  }
  private mounted() {
    Root.on('show-consolidated-section', (show: boolean) => {
      this.showCancelButton = show ;
    });
  }
}
export default toNative(VirtualMeetingSessionAnalytics);
